/** selectionBox组件 弹窗类型
 * - 0 单选框类型带叉号
 * - 1 picker带确定取消
 * - 2 cell带标题类型且带叉号
 * - 3 cell不带标题类型且带叉号
 * - 4 页面跳转选择
 * - 5 无弹窗
 * - 6 自定义内容带叉号
 * */
export enum SELECTION_BOX_POP_TYPE {
  RADIO_POP,
  PICKER_POP,
  CELL_TITLE_POP,
  CELL_POP,
  PAGE_JUMP,
  NO_TYPE,
  DEFINE_COMPONENT,
  AREA_POP
}

// 上传资源类型 1:图文结合，2:图片 3:文本(必传)
export enum STORAGE_TYPE {
  IMAGE_TEXT_UPLOAD = 1,
  PICTURE_UPLOAD = 2,
  TEXT_UPLOAD = 3
}

/** 资料类型
 * - 2 每日解析
 * - 3 试卷
 * - 4 作文
 * - 5 手抄报
 * - 6 笔记
 * - 7 读后感
 * */
export enum RESOURCE_TYPE {
  DAILY_ANALYSIS = 2,
  TEST_PAPER = 3,
  COMPOSITION = 4,
  HAND_COPY = 5,
  NOTE = 6,
  READ_IMPRESSIONS = 7
}

/** app分享类型
 * -1: QQ好友
 * -2: QQ空间
 * -3: 朋友圈
 * -4: 微信好友
 **/
export enum APP_SHARE_TYPE {
  QQ_FRIENDS = 1,
  QQ_ZONE = 2,
  WECHAT_MOMENTS = 3,
  WECHAT_FRIENDS = 4
}

/** 消息类型
 * -0: 已读
 * -1: 未读
 **/
export enum MSG_TYPE {
  READ,
  UNREAD
}

/** 消息跳转类型
 * -0: 无跳转
 * -1: 再次上传
 * -2: 质检通过
 **/
export enum MSG_JUMP_TYPE {
  NO_JUMP,
  UPLOAD_AGAIN,
  QUALITY_INSPECTION_PASS
}

/** 奖品类型
 * -1: 虚拟
 * -2: 实物,
 * -3: 再来一次,
 * -4: 谢谢参与,
 * -5: Q币领奖类型,
 * -6: 手机号领奖类型
 **/
export enum PRIZE_TYPE {
  FICTITIOUS = 1,
  MATTER = 2,
  ONCE_MORE = 3,
  THANKS = 4,
  REWARD_Q_COIN = 5,
  REWARD_PHONE = 6
}
